import { Row } from '@design-system/components/grid/grid';
import { Typography } from '@design-system/components/typography/typography';
import { ButtonLink } from '@design-system/components/button/button';
import { PATHS } from '@client/routes';
import { OFFERS_SCROLL_TO_PROGRAM_PARAM } from '@client/new/pages/bundles/common/helpers';

export const ProgramSavedToast = (p: {
  creatorId: number;
  programName?: string;
}) => {
  const { creatorId, programName } = p;
  const offersUrl = programName
    ? `${PATHS.BUNDLES(
        creatorId,
      )}?${OFFERS_SCROLL_TO_PROGRAM_PARAM}=${encodeURIComponent(programName)}`
    : PATHS.BUNDLES(creatorId);

  return (
    <Row alignCenter>
      <Typography variant="body" fontWeight="medium">
        Program saved. Now let&apos;s price and package it so people can buy it.
      </Typography>

      <ButtonLink variant="text" color="primary" to={offersUrl}>
        Go to offers
      </ButtonLink>
    </Row>
  );
};
